module.exports = __webpack_public_path__ + "img/pc.f57ab2e8.png";